<!--<template>-->
<!--  <div class="container w-full p-8 mx-auto" v-if="settings">-->
<!--    <div class="grid md:gap-5 md:grid-cols-4">-->
      <!-- <div class="w-80"> -->
<!--        <h1 class="text-2xl font-bold tracking-wide text-gray-700">-->
<!--          Have any questions?-->
<!--        </h1>-->
<!--        <p class="my-4 text-sm font-light text-gray-500">-->
<!--          Lorem Lorem ipsum dolor sit amet consectetur adipisicing elit.-->
<!--          Reprehenderit suscipit voluptate facere.-->
<!--        </p>-->
<!--        <button-->
<!--          class="h-12 px-4 py-2 font-light text-white bg-blue-800 rounded-md w-44"-->
<!--        >-->
<!--          Get in touch-->
<!--        </button>-->
<!--      </div> -->-->
<!--      <div class="flex flex-col mt-3 md:items-center md:w-52 md:mt-0">-->
<!--        <div class="flex flex-col">-->
<!--          <h1 class="mb-3 text-sm font-medium text-gray-500 uppercase">{{ $t('footer.header1') }}</h1>-->
<!--          <a-->
<!--            class="mb-3 text-sm font-light text-gray-500"-->
<!--            target="__blank"-->
<!--            :href="`${this.$store.state.baseUrl}pages/contact`"-->
<!--            >{{ $t('footer.sub1') }}</a-->
<!--          >-->
<!--          <a-->
<!--            class="mb-3 text-sm font-light text-gray-500"-->
<!--            target="__blank"-->
<!--            :href="`${this.$store.state.baseUrl}privacy/policy`"-->
<!--            >{{ $t('footer.sub2') }}</a-->
<!--          >-->
<!--          <a-->
<!--            class="mb-3 text-sm font-light text-gray-500"-->
<!--            target="__blank"-->
<!--            :href="`${this.$store.state.baseUrl}pages/terms`"-->
<!--            >{{ $t('footer.sub3') }}</a-->
<!--          >-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="flex flex-col mt-3 md:mt-0 md:items-center md:w-52">-->
<!--        <div class="flex flex-col">-->
<!--          <h1 class="mb-3 text-sm font-medium text-gray-500 uppercase">-->
<!--            {{ $t('footer.header2') }}-->
<!--          </h1>-->
<!--          <a-->
<!--            class="mb-3 text-sm font-light text-gray-500"-->
<!--            target="__blank"-->
<!--            :href="`${this.$store.state.baseUrl}register/driver`"-->
<!--            >{{ $t('footer.sub4') }}</a-->
<!--          >-->
<!--          <a-->
<!--            class="mb-6 text-sm font-light text-gray-500"-->
<!--            target="__blank"-->
<!--            :href="`${this.$store.state.baseUrl}register/vendor`"-->
<!--            >{{ $t('footer.sub5') }} {{ settings.strings.app_name }}?</a-->
<!--          >-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="flex flex-col mt-3 md:mt-0 md:items-center md:w-52">-->
<!--        <div class="flex flex-col">-->
<!--          <h1 class="mb-3 text-sm font-medium text-gray-500 uppercase">{{ $t('footer.header3') }}</h1>-->
<!--          <a href="" class="mb-3 text-sm font-light text-gray-500"-->
<!--            >{{ $t('footer.sub6') }}</a-->
<!--          >-->
<!--          <a href="" class="mb-3 text-sm font-light text-gray-500">{{ $t('footer.sub7') }}</a>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="flex flex-col mt-3 md:mt-0 md:items-center md:w-52">-->
<!--        <div class="flex flex-col">-->
<!--          <h1 class="mb-3 text-sm font-medium text-gray-500 uppercase">{{ $t('footer.header5') }}</h1>-->
<!--          <a-->
<!--            class="mb-3 text-sm font-light text-gray-500"-->
<!--            v-for="vendor in vendors"-->
<!--            :key="vendor.id"-->
<!--          >-->
<!--            <a-->
<!--              class="text-gray-500"-->
<!--              :href="-->
<!--                $router.resolve({-->
<!--                  params: {-->
<!--                    id: vendor.id,-->
<!--                    slug: sanitizeTitle(`${vendor.slug}`),-->
<!--                  },-->
<!--                }).href-->
<!--              "-->
<!--              >{{ vendor.name }}</a-->
<!--            >-->
<!--          </a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <p class="mt-10 text-sm font-light text-gray-500">-->
<!--      {{ settings.strings.website.websiteFooterBrief }}-->
<!--    </p>-->
<!--    <div class="flex justify-end space-x-2">-->
<!--      <a-->
<!--        :href="-->
<!--          settings.strings.website.social-->
<!--            ? settings.strings.website.social.fbLink-->
<!--            : '#'-->
<!--        "-->
<!--        ><img src="/img/icons/facebook.png" class="w-4 h-4" alt=""-->
<!--      /></a>-->
<!--      <a-->
<!--        :href="-->
<!--          settings.strings.website.social-->
<!--            ? settings.strings.website.social.igLink-->
<!--            : '#'-->
<!--        "-->
<!--        ><img src="/img/icons/instagram.png" class="w-4 h-4" alt=""-->
<!--      /></a>-->
<!--      <a-->
<!--        :href="-->
<!--          settings.strings.website.social-->
<!--            ? settings.strings.website.social.twLink-->
<!--            : '#'-->
<!--        "-->
<!--        ><img src="/img/icons/twitter.png" class="w-4 h-4" alt=""-->
<!--      /></a>-->
<!--    </div>-->
<!--    <hr class="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700">-->
<!--  </div>-->
<!--</template>-->

<template>
  <footer class="bg-gray-900 text-white" v-if="settings">
    <!-- Main Footer Content -->
    <div class="container mx-auto px-6 py-16">
      <!-- Top Section with Brand and Newsletter -->
      <div class="grid lg:grid-cols-5 gap-12 mb-12">
        <!-- Brand Section -->
        <div class="lg:col-span-2">
          <div class="flex items-center space-x-3 mb-6">
            <!--<div class="w-10 h-10 rounded-xl flex items-center justify-center" style="background: linear-gradient(135deg, #002790, #008a11);">-->
            <!--  <span class="text-white font-bold text-lg">{{ settings.strings.app_name.charAt(0) }}</span>-->
            <!--</div>-->
            <img class="w-12 h-12" src="/img/icons/logo.png" />
            <span class="text-2xl font-bold text-white">{{
              settings.strings.app_name
            }}</span>
          </div>
          <p class="text-gray-300 text-base leading-relaxed mb-6 max-w-md">
            {{ settings.strings.website.websiteFooterBrief }}
          </p>

          <!-- Newsletter Signup -->
          <div class="bg-gray-800 rounded-2xl p-6 border border-gray-700">
            <p class="text-gray-400 text-sm mb-4">
              {{ $t("footer.description") }}
            </p>
            <!--  <h3 class="text-lg font-semibold mb-3">Stay Updated</h3>-->
            <!--  <p class="text-gray-400 text-sm mb-4">Get the latest updates and offers delivered to your inbox.</p>-->
            <!--  <div class="flex space-x-3">-->
            <!--    <input -->
            <!--      type="email" -->
            <!--      placeholder="Enter your email"-->
            <!--      class="flex-1 px-4 py-3 bg-gray-700 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500/20 transition-all duration-200"-->
            <!--    />-->
            <!--    <button -->
            <!--      class="px-6 py-3 text-white font-medium rounded-xl transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 focus:ring-offset-gray-900"-->
            <!--      style="background: linear-gradient(135deg, #002790, #008a11);"-->
            <!--    >-->
            <!--      Subscribe-->
            <!--    </button>-->
            <!--  </div>-->
          </div>
        </div>

        <!-- Links Sections -->
        <div class="lg:col-span-3 grid md:grid-cols-3 gap-8">
          <!-- Company Links -->
          <div>
            <h3 class="text-lg font-semibold mb-6 text-white">
              {{ $t("footer.header1") }}
            </h3>
            <div class="space-y-4">
              <a
                :href="`${this.$store.state.baseUrl}pages/contact`"
                target="_blank"
                class="block text-gray-300 hover:text-white hover:translate-x-1 transition-all duration-200 group"
              >
                <span class="flex items-center">
                  {{ $t("footer.sub1") }}
                  <svg
                    class="w-4 h-4 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </span>
              </a>
              <a
                :href="`${this.$store.state.baseUrl}privacy/policy`"
                target="_blank"
                class="block text-gray-300 hover:text-white hover:translate-x-1 transition-all duration-200 group"
              >
                <span class="flex items-center">
                  {{ $t("footer.sub2") }}
                  <svg
                    class="w-4 h-4 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </span>
              </a>
              <a
                :href="`${this.$store.state.baseUrl}pages/terms`"
                target="_blank"
                class="block text-gray-300 hover:text-white hover:translate-x-1 transition-all duration-200 group"
              >
                <span class="flex items-center">
                  {{ $t("footer.sub3") }}
                  <svg
                    class="w-4 h-4 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </span>
              </a>
            </div>
          </div>

          <!-- Partnership Links -->
          <div>
            <h3 class="text-lg font-semibold mb-6 text-white">
              {{ $t("footer.header2") }}
            </h3>
            <div class="space-y-4">
              <a
                :href="`${this.$store.state.baseUrl}register/driver`"
                target="_blank"
                class="block text-gray-300 hover:text-white hover:translate-x-1 transition-all duration-200 group"
              >
                <span class="flex items-center">
                  {{ $t("footer.sub4") }}
                  <svg
                    class="w-4 h-4 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </span>
              </a>
              <a
                :href="`${this.$store.state.baseUrl}register/vendor`"
                target="_blank"
                class="block text-gray-300 hover:text-white hover:translate-x-1 transition-all duration-200 group"
              >
                <span class="flex items-center">
                  {{ $t("footer.sub5") }} {{ settings.strings.app_name }}?
                  <svg
                    class="w-4 h-4 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </span>
              </a>
            </div>

            <!-- Support Section -->
            <div class="mt-8">
              <h4 class="text-lg font-semibold mb-4 text-white">
                {{ $t("footer.header3") }}
              </h4>
              <div class="space-y-3">
                <a
                  href="#"
                  class="block text-gray-300 hover:text-white hover:translate-x-1 transition-all duration-200 group"
                >
                  <span class="flex items-center">
                    {{ $t("footer.sub6") }}
                    <svg
                      class="w-4 h-4 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 5l7 7-7 7"
                      ></path>
                    </svg>
                  </span>
                </a>
                <a
                  href="#"
                  class="block text-gray-300 hover:text-white hover:translate-x-1 transition-all duration-200 group"
                >
                  <span class="flex items-center">
                    {{ $t("footer.sub7") }}
                    <svg
                      class="w-4 h-4 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 5l7 7-7 7"
                      ></path>
                    </svg>
                  </span>
                </a>
              </div>
            </div>
          </div>

          <!-- Vendors Section -->
          <div>
            <h3 class="text-lg font-semibold mb-6 text-white">
              {{ $t("footer.header5") }}
            </h3>
            <div class="space-y-3">
              <a
                v-for="vendor in vendors.slice(0, 6)"
                :key="vendor.id"
                :href="
                  $router.resolve({
                    params: {
                      id: vendor.id,
                      slug: sanitizeTitle(`${vendor.slug}`),
                    },
                  }).href
                "
                class="block text-gray-300 hover:text-white hover:translate-x-1 transition-all duration-200 group"
              >
                <span class="flex items-center">
                  {{ vendor.name }}
                  <svg
                    class="w-4 h-4 ml-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </span>
              </a>
              <a
                v-if="vendors.length > 6"
                href="/vendors"
                class="inline-flex items-center text-sm font-medium hover:translate-x-1 transition-all duration-200"
                style="color: #002790"
              >
                View all vendors
                <svg
                  class="w-4 h-4 ml-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Section -->
    <div class="border-t border-gray-800">
      <div class="container mx-auto px-6 py-8">
        <div
          class="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0"
        >
          <!-- Copyright -->
          <div class="text-gray-400 text-sm">
            © {{ new Date().getFullYear() }} {{ settings.strings.app_name }}.
            All rights reserved.
          </div>

          <!-- Social Links -->
          <div class="flex items-center space-x-6">
            <span class="text-gray-400 text-sm font-medium">Follow us:</span>
            <div class="flex space-x-4">
              <a
                :href="settings.strings.website.social?.fbLink || '#'"
                class="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-xl flex items-center justify-center transition-all duration-200 transform hover:scale-110 group"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  class="w-5 h-5 text-gray-400 group-hover:text-white transition-colors duration-200"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                  />
                </svg>
              </a>
              <a
                :href="settings.strings.website.social?.igLink || '#'"
                class="w-10 h-10 bg-gray-800 hover:bg-pink-600 rounded-xl flex items-center justify-center transition-all duration-200 transform hover:scale-110 group"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  class="w-7 h-7 text-gray-400 group-hover:text-white transition-colors duration-200"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                >
                  <path
                    d="M20.445 5h-8.891A6.559 6.559 0 0 0 5 11.554v8.891A6.559 6.559 0 0 0 11.554 27h8.891a6.56 6.56 0 0 0 6.554-6.555v-8.891A6.557 6.557 0 0 0 20.445 5zm4.342 15.445a4.343 4.343 0 0 1-4.342 4.342h-8.891a4.341 4.341 0 0 1-4.341-4.342v-8.891a4.34 4.34 0 0 1 4.341-4.341h8.891a4.342 4.342 0 0 1 4.341 4.341l.001 8.891z"
                  />
                  <path
                    d="M16 10.312c-3.138 0-5.688 2.551-5.688 5.688s2.551 5.688 5.688 5.688 5.688-2.551 5.688-5.688-2.55-5.688-5.688-5.688zm0 9.163a3.475 3.475 0 1 1-.001-6.95 3.475 3.475 0 0 1 .001 6.95zM21.7 8.991a1.363 1.363 0 1 1-1.364 1.364c0-.752.51-1.364 1.364-1.364z"
                  />
                </svg>
              </a>
              <a
                :href="settings.strings.website.social?.twLink || '#'"
                class="w-10 h-10 bg-gray-800 hover:bg-blue-400 rounded-xl flex items-center justify-center transition-all duration-200 transform hover:scale-110 group"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  class="w-5 h-5 text-gray-400 group-hover:text-white transition-colors duration-200"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from "axios";
export default {
  name: "FooterView",
  data() {
    return {
      settings: null,
      vendors: null,
      base_url: this.$store.state.baseUrl,
    };
  },

  mounted() {
    this.$store.dispatch("fetchSettings", this.items).then(() => {
      this.settings = this.$store.state.settings;
    });
    let selectedLanguage = localStorage.getItem("selectedLanguage");
    const headers = {
      lang: selectedLanguage,
    };
    axios
      .get(this.base_url + "api/vendor/types", { headers })
      .then((response) => {
        let vendorTypes = response.data;
        this.vendors = vendorTypes.slice(0, 4);
      })
      .catch((error) => console.log(error));
  },

  methods: {
    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
  },
};
</script>
